import Model from '@/models/Model'

export default class SlSaleTicket extends Model {
    resource() {
        return 'sl_sale_ticket'
    }
}